module.exports = __webpack_public_path__ + "img/20210625_Teilkauf_2850.d79a3c9c.webp";